module.exports = __webpack_public_path__ + "media/images/icons/board-e4b884b741c0a7b889b7c77b2df35eec.svg";